import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import establecimientoService from '../../../service/administracion/establecimientoService';
import cajaService from '../../../service/administracion/cajaService';


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export const lista_tipo = [{ id: 1, nombre: "COBRANZA" }, { id: 2, nombre: "CAJA CHICA" }]

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            listaEstablecimiento: [],
            estados: estadoMock.values,
            filter: {
                nombre: '',
                Establecimiento: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            idEstablecimiento: 0,
            codigoSunat: '',
            idTipoCaja: 0,
            listaEstablecimiento: [],
            tipos: []

        };
    };

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            codigoSunat: '',
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cajaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Metodo de Pago.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cajaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Metodo de Pago.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cajaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await cajaService.eliminar(values);
            else
                response = await cajaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.listaEstablecimiento = this.state.listaEstablecimiento ? this.state.listaEstablecimiento : [];
        formValues.tipos = lista_tipo;

        this.setState({ visible: true, formValues });

    };


    handleEdit = async (values) => {
        const response = await cajaService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    idEstablecimiento: response.iD_Establecimiento,
                    listaEstablecimiento: this.state.listaEstablecimiento,
                    tipos: lista_tipo,
                    idTipoCaja: response.idTipoCaja,


                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await cajaService.registrar(values);
            else
                response = await cajaService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                form.setFieldsValue(empty);
                form.resetFields();
                this.setState({ visible: false, formValues: empty });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, cajaService.paginacion);

        const establecimientos = await establecimientoService.principales();
        this.setState({
            loadingSource: false,
            listaEstablecimiento: establecimientos ? establecimientos : [],
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Caja"
                    onNew={this.handleNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    listaEstablecimiento={this.state.listaEstablecimiento}
                    tipos={lista_tipo}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}